// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "luana-carolina.firebaseapp.com",
  "projectId": "luana-carolina",
  "storageBucket": "luana-carolina.appspot.com",
  "messagingSenderId": "301155649996",
  "appId": "1:301155649996:web:ff30979e6a16f94c47f569",
  "measurementId": "G-QWH8V67V17",
  "apiKey": "AIzaSyDlBUFtI6sHHGDN3FWCbm1bCX1xwgDak-E"
};
